// API refund + komplain — Phase 1F.
//
// ⛔ NOL KONSTANTA BISNIS DI BERKAS INI. Daftar status, penyebab, metode
// bayar, ambang Rp5 juta, dan wewenang pengguna SEMUANYA datang dari
// `/meta`. Menyalin salah satunya ke frontend berarti layar akan menggambar
// batas yang bukan batas sebenarnya begitu backend-nya berubah — dan
// pengguna baru tahu saat pengajuannya ditolak tanpa penjelasan yang cocok
// dengan apa yang ia lihat.
import { api } from "./api";
// Sumber TUNGGAL apiErrorMessage adalah inventoryApi.js — diimpor dari
// sana, bukan dirantai lewat purchasingApi. Rantai yang panjang membuat
// sumbernya susah ditemukan saat pesan galatnya perlu diubah.
export { apiErrorMessage } from "./inventoryApi";

// ---------- Refund ----------

/** Status, penyebab, metode bayar, AMBANG, dan wewenang pengguna ini. */
export const getRefundMeta = () => api.get("/refunds/meta");

export const listRefunds = (params) => api.get("/refunds", { params });
export const getRefund = (id) => api.get(`/refunds/${id}`);

/** body: { fa_id, cause, amount_idr, alasan,
 *          paket_dibayar?, paket_realisasi?, hari_kerja_realisasi? }
 *
 * ⚠ Tiga field terakhir WAJIB kalau cause = KETERLAMBATAN (Q100) — backend
 * menolak tanpa itu, dan penolakannya menyebut sebabnya. */
export const createRefund = (body) => api.post("/refunds", body);

export const approveRefund = (id) => api.post(`/refunds/${id}/approve`, {});
export const rejectRefund = (id, body) => api.post(`/refunds/${id}/reject`, body);
export const prosesRefund = (id, body) => api.post(`/refunds/${id}/proses`, body);

/** body: { bukti_url? } — WAJIB terisi kalau metodenya TRANSFER_BALIK (Q102). */
export const selesaikanRefund = (id, body) =>
  api.post(`/refunds/${id}/selesai`, body);

// ---------- Komplain ----------

export const getComplaintMeta = () => api.get("/complaints/meta");
export const listComplaints = (params) => api.get("/complaints", { params });
export const getComplaint = (id) => api.get(`/complaints/${id}`);

/** body: { kategori, deskripsi, sumber, fa_id? | design_request_id? }
 *
 * ⚠ `kategori` BEBAS — nol daftar tertutup. Layar boleh menyarankan, tapi
 * nol boleh membatasi: daftar yang salah menolak komplain sungguhan di depan
 * customer. */
export const createComplaint = (body) => api.post("/complaints", body);

export const tanganiComplaint = (id) => api.post(`/complaints/${id}/tangani`, {});

/** Langkah 26 Pareto v1 — body: { tahap_asal, pic_employee_id } (null = kosongkan). */
export const isiAkarComplaint = (id, body) => api.patch(`/complaints/${id}/akar`, body);

/** body: { penyelesaian, ditutup?, refund_id? } */
export const selesaikanComplaint = (id, body) =>
  api.post(`/complaints/${id}/selesai`, body);
